import { s3_asset } from "../hooks/General";

export const ICONS = {
  tick: s3_asset + "/public/assets/icons/tick.svg",
  cross: s3_asset + "/public/assets/icons/cross.svg",
  eye: s3_asset + "/public/assets/icons/eye.svg",
  copy: s3_asset + "/public/assets/icons/copy.svg",
  pen: s3_asset + "/public/assets/icons/pen.svg",
};
